<template>
  <div class="hero center-text">
    <div class="hero-media">
      <img :src="cover" class="hero-image" alt="Cover" />
    </div>

    <div class="hero-content clear">
      <img :src="logo" class="logo-image" alt="Logo de BGS" />
      <h2>{{ $t('slogan') }}</h2>
      <p class="link">
        <a v-if="link" :href="link | mailTo" target="_blank">{{ $t('contactUs') }}</a>
      </p>
      <!--<language-picker></language-picker>-->
    </div>

    <a href="#firstStep" class="goDown">
      <font-awesome-icon icon="chevron-down"></font-awesome-icon>
    </a>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import Logo from '@/assets/images/logo.png';
// import LanguagePicker from './LanguagePicker.vue';


export default {
  name: 'TheHero',
  components: {
    FontAwesomeIcon,
    // LanguagePicker,
  },
  props: {
    cover: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      logo: Logo,
    };
  },
  filters: {
    mailTo(mail) {
      return `mailto:${mail}`;
    },
  },
};
</script>

<style lang="scss" scoped>
div.hero {
  height: 100vh;
  width: 100%;
  background: transparent no-repeat center center;
  background-size: cover;
  position: relative;

  div.hero-media {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;

    img {
      position: absolute;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      -webkit-filter: brightness(50%) grayscale(100%);
      filter: brightness(50%) grayscale(100%);
    }
  }

  div.hero-content {
    position: relative;
    top: 25%;
    transform: translateY(-25%);
    margin: 0 auto;
    padding: 20px;
    // background-color: rgba(255, 255, 255, 0.6);

    img {
      padding: 10px;
      width: 20%;
    }

    h2 {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
      letter-spacing: 2px;
      text-transform: uppercase;
    }

    p {
      padding: 20px 0 0 10px;
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 1px;
      text-transform: uppercase;

      a {
        padding: 15px;
        border: 1px solid #fff;
        border-radius: 5px;
        color: #fff;
        text-decoration: none;
        -webkit-transition: background-color 0.5s, color 0.5s;
        transition: background-color 0.5s, color 0.5s;

        &:hover {
          border: 1px solid #76665b;
          background-color: #76665b;
          color: #fff;
        }
      }
    }
  }

  a#goDown {
    position: absolute;
    // left: 50%;
    bottom: -20px;
    // transform: translateX(-50%);
    z-index: 99;
  }
}

@media only screen and (max-width: 970px) {
  img {
    &.hero-image {
      width: auto !important;
    }

    &.logo-image {
      width: 35% !important;
    }
  }
}

@media only screen and (max-width: 600px) {
  img {
    &.logo-image {
      width: 50% !important;
    }
  }

  p {
    &.link {
      color: #fff;

      a {
        border: 1px solid #76665b !important;
        background-color: #76665b;
        color: #fff !important;
      }
    }
  }
}
</style>
